import {
    useConfluenceFreeIntent,
    useDevAiIntent,
    useJiraIntent,
    useJiraServiceManagementIntent
} from "@/components/user-context";

import { LoggedOutConfluenceFree } from "./confluence";
import { LoggedOutDefault } from "./default";
import { LoggedOutDevAI } from "./devai";
import { LoggedOutJira } from "./jira";
import { LoggedOutJiraServiceManagement } from "./jira-service-management";

export const LoggedOut = () => {
    const isConfluenceFree = useConfluenceFreeIntent();
    const isJira = useJiraIntent();
    const isJSM = useJiraServiceManagementIntent();
    const isDevAI = useDevAiIntent();

    if (isConfluenceFree) {
        return <LoggedOutConfluenceFree />;
    }

    if (isJira) {
        return <LoggedOutJira />;
    }

    if (isJSM) {
        return <LoggedOutJiraServiceManagement />;
    }

    if (isDevAI) {
        return <LoggedOutDevAI />;
    }

    // bxpkit catch-all
    return <LoggedOutDefault />;
};
